import { DateRange } from '@/hooks/useApi/types'
import { VarianceBadge } from '../../VarianceBadge/VarianceBadge'
import { Badge } from '@/components/atoms'
import { formatDateForChart } from '@/utils/formatDateForChart'

export type ComparisonCardStatsProps = {
    subtitle: string
    value: string | React.ReactElement
    footerText: string
    current?: number
    previous?: number
    dateRange: DateRange
}

export const ComparisonCardStats: React.FC<ComparisonCardStatsProps> = ({
    subtitle,
    value,
    footerText,
    current,
    previous,
    dateRange,
}) => {
    const formattedStartDate = formatDateForChart(dateRange.startDate)
    const formattedEndDate = formatDateForChart(dateRange.endDate)

    return (
        <div className="grid gap-1">
            <div className="row flex items-center gap-2">
                <div
                    className="text-xs-tight font-medium text-subtle"
                    data-testid="comparison-card-subtitle"
                >
                    {subtitle}
                </div>
                <Badge className="text-label-xsmall inline-flex h-5 items-center !rounded-[6px]">
                    {formattedStartDate} - {formattedEndDate}
                </Badge>
            </div>
            <div className="row flex items-center gap-2">
                <p
                    className="text-sm font-semibold"
                    data-testid="comparison-card-value"
                >
                    {value}
                </p>
                {current != null &&
                    previous != null &&
                    previous !== current && (
                        <VarianceBadge
                            previous={previous}
                            current={current}
                            isReversed={true}
                        />
                    )}
            </div>
            <div
                className="row text-xs-tight font-medium text-subtle"
                data-testid="comparison-card-footer"
            >
                {footerText}
            </div>
        </div>
    )
}
